import React, { Component } from 'react'
import { connect } from 'react-redux'
import { SetIsShowLoginDialog } from '../../../Interface'
import './index.scss'

import Slick from 'react-slick'

import { Trans } from 'react-i18next'
import i18n from '@/i18n'

class GalleryAreaEn extends Component {
    slickRef1
    slick1ChangeTime = Date.now()

    interval

    componentDidMount() {
        this.interval = setInterval(this.slickAnimationInterval, 500)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    slickAnimationInterval = () => {
        const now = Date.now()
        if (now - this.slick1ChangeTime >= (1000 + Math.floor(Math.random() * 10000)) && this.slickRef1) {
            this.slickRef1.slickNext()
            this.slick1ChangeTime = now
        }
    }

    render() {
        const { currentUser } = this.props
        const slickSetting = {
            infinite: true,
            speed: 500,
            swipeToSlide: true,
            variableWidth: true
        }
        const videoArr = [
            {
                src: "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/gallery/en_gallery_Dance Class.mp4",
                name: "Dance Class",
                _id: "60d57f84e182da1320e0edc8"
            },
            { 
                src: "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/gallery/en_gallery_Ecommerce Fashion.mp4",
                name: "Ecommerce Fashion",
                _id: "61c053734ec47b173318315d"
            },
            { 
                src: "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/gallery/en_gallery_Ecommerce Shoes.mp4",
                name: "Ecommerce Shoes",
                _id: "5f7eb679f67f8c002da0bbb1"
            },
            { 
                src: "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/gallery/en_gallery_event promo.mp4",
                name: "Event Promo",
                _id: "625924a712f1e0002c2d1c9b"
            },
            { 
                src: "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/gallery/en_gallery_Fashion Item.mp4",
                name: "Fashion Item",
                _id: "64882bda21d28f4ea92f5ee1"
            },
            { 
                src: "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/gallery/en_gallery_Fashion Lookbook.mp4",
                name: "Fashion Lookbook",
                _id: "5f3636cc8830e7004b453479"
            },
            { 
                src: "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/gallery/en_gallery_Food Delivery.mp4",
                name: "Food Delivery",
                _id: "61ce6f72fcef190c19160d0b"
            },
            { 
                src: "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/gallery/en_gallery_furniture.mp4",
                name: "Furniture",
                _id: "61ef5e61001cae004f8e85a6"
            },
            { 
                src: "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/gallery/en_gallery_Getaway.mp4",
                name: "Getaway",
                _id: "63d8b92e067b9a005060ed23"
            },
            { 
                src: "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/gallery/en_gallery_gym.mp4",
                name: "Gym",
                _id: "62503441fd73a50033db5bba"
            },
            { 
                src: "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/gallery/en_gallery_Laundromat.mp4",
                name: "Laundromat",
                _id: "5d49445bfbd35d002ad4cfee"
            },
            { 
                src: "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/gallery/en_gallery_Local Pub.mp4",
                name: "Local Pub",
                _id: "617a6b8e5f47280e144d8eeb"
            },
            { 
                src: "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/gallery/en_gallery_Men's Fashion.mp4",
                name: "Men's Fashion",
                _id: "6258fc90067d65060f00ae05"
            },
            { 
                src: "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/gallery/en_gallery_realtor.mp4",
                name: "Realtor",
                _id: "642a5834cf8f9e0253354347"
            },
            { 
                src: "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/gallery/en_gallery_Skincare.mp4",
                name: "Skincare",
                _id: "60a5fff90b1d7b003539d686"
            },
        ]
        return (
            <div className='gallery-area-en-root-container'>
                <div className='heading'>
                    <Trans i18nKey="web.newhome.gallery.en.title">
                        <span />
                    </Trans>
                </div>
                <div className='top-des'>{i18n.t("web.newhome.gallery.en.des")}</div>
                <div className='gallery-area-en-body'>
                    <Slick {...slickSetting}
                        ref={ref => this.slickRef1 = ref}
                    >
                        {
                            videoArr.map(item => (
                                <>
                                    <video autoPlay loop muted src={item.src} onClick={this.props.onThumbnailClicked(item._id)}/>
                                    <div className='hastag' onClick={this.props.onThumbnailClicked(item._id)}>{`#${item.name}`}</div>
                                </>
                            ))
                        }
                    </Slick>
                </div>
                {/* <div className='middle-des'>
                    <Trans i18nKey="web.newhome.gallery.en.des2">
                        <br />
                    </Trans>
                </div> */}
                <div className='setting-btn' onClick={() => {
                    if (currentUser) this.props.history.push('/designselect')
                    else SetIsShowLoginDialog(true)
                }}>
                    {i18n.t("web.newhome.gallery.en.button")}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    currentUser: state.userStore.user,
    lang: state.langStore.lang
})

export default connect(mapStateToProps, null)(GalleryAreaEn)